import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackUrl } from '@/app/analytics/sectionTracking';

export function useSectionAccess() {
	const location = useLocation();
	const prevPathRef = useRef<string | null>(null);

	useEffect(() => {
		const { pathname } = location;

		if (!pathname || prevPathRef.current === pathname) return;

		prevPathRef.current = pathname;
		// Fire-and-forget: tracking failures are already reported by the axios
		// error-reporting interceptor, so just swallow the rejection here.
		trackUrl(pathname).catch(() => {});
	}, [location.pathname]);
}
